import { OrderType } from './order_types';
import type { ViewOrder } from './ViewOrder';

/** Orders with an editable limit price. */
export function isPriceEditableOrder(order: ViewOrder): boolean {
  return order.type === OrderType.limit || order.type === OrderType.stopLimit;
}

/** Orders with an editable trigger price. */
export function isTriggerEditableOrder(order: ViewOrder): boolean {
  return order.type === OrderType.stopLimit || order.type === OrderType.stopMarket;
}

/** Orders that support editing at all (price, trigger or size). */
export function isEditableOrder(order: ViewOrder): boolean {
  return isPriceEditableOrder(order) || isTriggerEditableOrder(order);
}
